// extracted by mini-css-extract-plugin
module.exports = {"container":"container-3fRWk","locationIcon":"locationIcon-1_qQ2"};